export default function Reasons() {
  const reasons = [
    {
      title: 'スピード対応',
      subtitle: '最短当日納品可能',
      description: '現場からの急ぎ依頼にも対応',
      image: 'https://public.readdy.ai/ai/img_res/23f2431e113ab192d6b096ec1bfa0fce.jpg',
      dark: true
    },
    {
      title: '専門行政書士が対応',
      subtitle: '建設業許可・労務安全に精通',
      description: 'ミスをゼロへ',
      image: 'https://readdy.ai/api/search-image?query=administrative%20scrivener%20professional%20certification%20and%20specialized%20construction%20law%20books%20on%20organized%20desk%2C%20official%20credentials%20and%20legal%20documents%20displayed%2C%20professional%20expertise%20atmosphere&width=600&height=400&seq=reason-002&orientation=landscape',
      badge: '専門性',
      dark: false
    },
    {
      title: 'オンライン完結',
      subtitle: '全国どこからでも依頼可能',
      description: '全国対応・オンライン対応可',
      image: 'https://readdy.ai/api/search-image?query=japan%20map%20with%20digital%20network%20connections%20and%20online%20video%20conference%20screen%20showing%20remote%20consultation%2C%20modern%20technology%20enabling%20nationwide%20service%20coverage&width=600&height=400&seq=reason-003&orientation=landscape',
      badge: '全国対応',
      dark: false
    }
  ];

  return (
    <section id="reasons" className="py-16 sm:py-24 bg-[#fafaf8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1a2332] leading-tight mb-4 sm:mb-6">
            選ばれる理由
          </h2>
          <p className="text-base sm:text-lg text-gray-600 leading-relaxed px-4">
            現場の負担を軽減し、本業に集中できる環境を提供します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className={`rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer ${
                reason.dark ? 'bg-[#1a2332]' : 'bg-[#f5f5f5]'
              }`}
            >
              {reason.badge && (
                <div className="p-4 sm:p-6 pb-0">
                  <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-white rounded-full text-[#1a2332] text-xs sm:text-sm font-bold whitespace-nowrap">
                    <i className="ri-check-line text-[#ff6b35]"></i>
                    {reason.badge}
                  </div>
                </div>
              )}
              
              <div className="p-4 sm:p-6">
                <div className={`text-2xl sm:text-3xl font-bold mb-2 ${reason.dark ? 'text-white' : 'text-[#1a2332]'}`}>
                  {reason.title}
                </div>
                <div className={`text-base sm:text-lg mb-4 sm:mb-6 ${reason.dark ? 'text-gray-300' : 'text-gray-600'}`}>
                  {reason.subtitle}
                </div>
                
                <div className="w-full h-48 sm:h-64 rounded-2xl overflow-hidden mb-4 sm:mb-6">
                  <img 
                    src={reason.image}
                    alt={reason.title}
                    className="w-full h-full object-cover"
                  />
                </div>

                <p className={`text-sm sm:text-base ${reason.dark ? 'text-gray-400' : 'text-gray-600'}`}>
                  {reason.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
